var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentAttached(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#727A82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.174 6.283A3.81 3.81 0 0 0 2.28 8.777c-.243.712-.243 1.734 0 2.446a3.857 3.857 0 0 0 2.603 2.434l.334.091 1.891.011L9 13.77v-1.233l-1.808-.012c-1.997-.014-1.925-.007-2.413-.238A2.523 2.523 0 0 1 3.334 10c0-.982.559-1.866 1.445-2.287.488-.231.416-.224 2.413-.238L9 7.463v-1.23l-1.792.003c-1.325.003-1.854.015-2.034.047M11 6.846v.617l1.808.012c1.998.014 1.925.007 2.416.24.535.254.952.677 1.209 1.227.132.282.234.685.234.923V10H17.91l-.019-.325a3.301 3.301 0 0 0-.397-1.416 3.842 3.842 0 0 0-2.377-1.916l-.334-.091-1.891-.011L11 6.23v.616M6.882 9.409c-.01.024-.013.305-.008.626l.009.582h6.234V9.383l-3.11-.008c-2.514-.007-3.112 0-3.125.034M14.2 11.3v1.233h-2.467v1.234H14.2v2.466h1.233l.008-1.225.009-1.225 1.225-.008 1.225-.009v-1.233h-2.467v-2.466H14.2V11.3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentAttached);
export default __webpack_public_path__ + "static/media/equipment-attached.e0e9cd86334d8b3c8a8998856ceee280.svg";
export { ForwardRef as ReactComponent };